var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.register = void 0;
const rename_1 = require("./rename");
const getFormatCodeSettings_1 = require("../configs/getFormatCodeSettings");
const getUserPreferences_1 = require("../configs/getUserPreferences");
function register(rootUri, languageService, getTextDocument, getConfiguration) {
    return (codeAction) => __awaiter(this, void 0, void 0, function* () {
        const data = codeAction.data;
        const document = getTextDocument(data.uri);
        const [formatOptions, preferences] = document ? yield Promise.all([
            (0, getFormatCodeSettings_1.getFormatCodeSettings)(getConfiguration, document.uri),
            (0, getUserPreferences_1.getUserPreferences)(getConfiguration, document.uri, rootUri),
        ]) : [{}, {}];
        if ((data === null || data === void 0 ? void 0 : data.type) === 'fixAll') {
            const fixs = data.fixIds.map(fixId => {
                try {
                    return languageService.getCombinedCodeFix({ type: 'file', fileName: data.fileName }, fixId, formatOptions, preferences);
                }
                catch (_a) { }
            });
            const changes = fixs.map(fix => { var _a; return (_a = fix === null || fix === void 0 ? void 0 : fix.changes) !== null && _a !== void 0 ? _a : []; }).flat();
            codeAction.edit = (0, rename_1.fileTextChangesToWorkspaceEdit)(changes, getTextDocument);
        }
        else if ((data === null || data === void 0 ? void 0 : data.type) === 'refactor') {
            const editInfo = languageService.getEditsForRefactor(data.fileName, formatOptions, data.range, data.refactorName, data.actionName, preferences);
            if (editInfo) {
                const edit = (0, rename_1.fileTextChangesToWorkspaceEdit)(editInfo.edits, getTextDocument);
                codeAction.edit = edit;
            }
        }
        else if ((data === null || data === void 0 ? void 0 : data.type) === 'organizeImports') {
            const changes = languageService.organizeImports({ type: 'file', fileName: data.fileName }, formatOptions, preferences);
            const edit = (0, rename_1.fileTextChangesToWorkspaceEdit)(changes, getTextDocument);
            codeAction.edit = edit;
        }
        return codeAction;
    });
}
exports.register = register;
//# sourceMappingURL=codeActionResolve.js.map